(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/select-eid-menu.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/select-eid-menu.js');

'use strict';

const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  route
} = svs.playerLoginReact.constants;
const {
  useHistory
} = ReactRouterDOM;
const {
  loginType
} = svs.playerLoginReact.constants;

const SelectEidMenu = _ref => {
  let {
    isLogin = true
  } = _ref;
  const history = useHistory();
  const isBankId = ReactRedux.useSelector(state => state.playerloginreact.playerLoginType) === loginType.BANKID;
  const onBankIdClick = () => {
    if (!isBankId) {
      svs.core.deviceSession.set('currentLoginMethod', 'customer_login', 'bankid');
      history.push(isLogin ? route.LOGIN_BANKID_START_ROUTE : route.REGISTRATE_BANKID_ROUTE);
    }
  };
  const onFrejaEidClick = () => {
    if (isBankId) {
      svs.core.deviceSession.set('currentLoginMethod', 'customer_login', 'frejaeid');
      history.push(isLogin ? route.LOGIN_FREJAEID_START_ROUTE : route.REGISTRATE_FREJAEID_ROUTE);
    }
  };
  const classes = 'f-uppercase fc-navy';
  return React.createElement(ItemsMenu, {
    branding: "login-react",
    centered: true,
    className: "padding-bottom-2"
  }, React.createElement(LinkItem, {
    className: classes,
    label: "BankID",
    onClick: onBankIdClick,
    selected: isBankId
  }), React.createElement(LinkItem, {
    className: classes,
    label: "Freja eID",
    onClick: onFrejaEidClick,
    selected: !isBankId
  }));
};
svs.playerLoginReact.sharedComponents.SelectEidMenu = SelectEidMenu;

 })(window);